module.exports = __webpack_public_path__ + "img/golem.43d82839.png";